import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import logoQWER from "./log_QWER.jpeg";
import mini3rd from "./3rdmini.jpg";
import endGif1 from "./end1.gif";
import endGif2 from "./end2.gif";
import endGif3 from "./end3.gif";
import { Analytics } from "@vercel/analytics/react";
import { useTranslation } from "react-i18next";
import i18n from "../src/lang/i18n";
import "./TestTimeline.css";

const extractYouTubeID = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

const formatDate = (dateObject) => {
  if (dateObject && dateObject.$date) {
    return dateObject.$date.split("T")[0];
  }
  return "";
};

const isMobile = () => {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent);
};

const getRandomEndGif = () => {
  const gifs = [endGif1, endGif2, endGif3];
  return gifs[Math.floor(Math.random() * gifs.length)];
};

const NewBawige = ({ darkMode, toggleDarkMode }) => {
  const [items, setItems] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const loader = useRef(null);
  const scrollTimeout = useRef(null);
  const [endGif, setEndGif] = useState(getRandomEndGif());
  const [sortOrder, setSortOrder] = useState("asc");
  const [menuOpen, setMenuOpen] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [isEventListOpen, setIsEventListOpen] = useState(false);
  const { t } = useTranslation();

  const containerStyle = {
    backgroundColor: "rgba(18, 18, 18, 0.2)",
    minHeight: "100vh",
    color: "#ffffff",
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    const hamburger = document.querySelector(".hamburger");
    hamburger.classList.toggle("active");
  };

  const closeMenu = () => {
    setMenuOpen(false);
    const hamburger = document.querySelector(".hamburger");
    hamburger.classList.remove("active");
  };

  const itemsPerPage = 15;

  const toggleEventList = () => {
    setIsEventListOpen(!isEventListOpen);
  };

  const loadMoreItems = async () => {
    if (isLoading || !hasMore) return;

    const filteredItems = allItems.filter((item) => {
      return !selectedEvent || (item.tag && item.tag.includes(selectedEvent));
    });

    const sortedFilteredItems = filteredItems.sort((a, b) => {
      const dateA = new Date(a.uploadDate.$date);
      const dateB = new Date(b.uploadDate.$date);
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });

    const nextPage = page + 1;
    const startIndex = nextPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const newItems = sortedFilteredItems.slice(startIndex, endIndex);

    if (newItems.length === 0) {
      setHasMore(false);
      return;
    }

    setIsLoading(true);
    try {
      const delay = isMobile() ? 150 : 300;
      await new Promise((resolve) => setTimeout(resolve, delay));

      setItems((prevItems) => [...prevItems, ...newItems]);
      setPage(nextPage);
      setHasMore(endIndex < sortedFilteredItems.length);
    } finally {
      setIsLoading(false);
    }
  };

  const handleScroll = () => {
    if (scrollTimeout.current) {
      clearTimeout(scrollTimeout.current);
    }

    const debounceTime = isMobile() ? 100 : 150;

    scrollTimeout.current = setTimeout(() => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      let scrollThreshold;
      if (isMobile()) {
        scrollThreshold = documentHeight * 0.5;
      } else {
        scrollThreshold = documentHeight - windowHeight - 100;
      }

      if (scrollTop >= scrollThreshold) {
        loadMoreItems();
      }
    }, debounceTime);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }
    };
  }, [isLoading, items, hasMore]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch("/newfandata.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        const sortedData = data.sort((a, b) => {
          const dateA = new Date(a.uploadDate.$date);
          const dateB = new Date(b.uploadDate.$date);
          return dateA - dateB;
        });
        setAllItems(sortedData);
        setItems(sortedData.slice(0, itemsPerPage));
        setHasMore(sortedData.length > itemsPerPage);
      } catch (error) {
        console.error("Error loading JSON data:", error);
      }
      setIsLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchEventList = async () => {
      try {
        const response = await fetch("/newFnasEPList.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setEventList(data);
      } catch (error) {
        console.error("Error loading event list:", error);
      }
    };
    fetchEventList();
  }, []);

  const getYouTubeAppLink = (url) => {
    const videoId = extractYouTubeID(url);
    if (!videoId) return url;
    if (/Android/i.test(navigator.userAgent)) {
      return `intent://www.youtube.com/watch?v=${videoId}#Intent;package=com.google.android.youtube;scheme=https;end`;
    }
    return `https://www.youtube.com/watch?v=${videoId}`;
  };

  const handleThumbnailClick = (url) => {
    const link = isMobile() ? getYouTubeAppLink(url) : url;
    window.open(link, "_blank");
  };

  const handleEventFilter = (event) => {
    const newEvent = event === selectedEvent ? null : event;
    setSelectedEvent(newEvent);
    setIsEventListOpen(false);

    const filteredItems = allItems.filter((item) => {
      return !newEvent || (item.tag && item.tag.includes(newEvent));
    });

    setItems(filteredItems.slice(0, itemsPerPage));
    setPage(0);
    setHasMore(filteredItems.length > itemsPerPage);
  };

  const handleSort = () => {
    setSortOrder((prevOrder) => {
      const newOrder = prevOrder === "asc" ? "desc" : "asc";
      const filteredItems = allItems.filter((item) => {
        return !selectedEvent || (item.tag && item.tag.includes(selectedEvent));
      });

      const sortedItems = filteredItems.sort((a, b) => {
        const dateA = new Date(a.uploadDate.$date);
        const dateB = new Date(b.uploadDate.$date);
        return newOrder === "asc" ? dateA - dateB : dateB - dateA;
      });

      setItems(sortedItems.slice(0, itemsPerPage));
      setPage(0);
      return newOrder;
    });
  };

  const onChangeLangKO = () => {
    i18n.changeLanguage("ko");
  };

  const onChangeLangJP = () => {
    i18n.changeLanguage("jp");
  };

  const onChangeLangENG = () => {
    i18n.changeLanguage("en");
  };

  const clearEventFilter = (e) => {
    e.stopPropagation();
    setSelectedEvent("");
    setItems(allItems.slice(0, itemsPerPage));
    setPage(0);
  };

  return (
    <div className="App" style={containerStyle}>
      <h1>{t("newFan")}</h1>
      <h3>{t("newFanNotice")}</h3>

      <div className="lang-switch">
        <button
          className={`lang-btn ${i18n.language === "ko" ? "active" : ""}`}
          onClick={onChangeLangKO}
        >
          KR
        </button>
        <button
          className={`lang-btn ${i18n.language === "en" ? "active" : ""}`}
          onClick={onChangeLangENG}
        >
          EN
        </button>
        <button
          className={`lang-btn ${i18n.language === "jp" ? "active" : ""}`}
          onClick={onChangeLangJP}
        >
          JP
        </button>
      </div>

      <button className="sort-button" onClick={handleSort}>
        {sortOrder === "asc" ? t("sortNew") : t("sortOld")}
      </button>

      <div className="event-picker">
        <div className="event-list-header" onClick={toggleEventList}>
          <h3 className="event-list-title">
            {selectedEvent ? t(selectedEvent) : t("filterTitle")}
          </h3>
          <div className="header-controls">
            {selectedEvent && (
              <button
                className="clear-filter"
                onClick={clearEventFilter}
                aria-label="Clear filter"
              >
                ×
              </button>
            )}
            <span
              className={`event-list-toggle ${isEventListOpen ? "open" : ""}`}
            >
              ▼
            </span>
          </div>
        </div>
        <div className={`event-list-content ${isEventListOpen ? "open" : ""}`}>
          {eventList.map((event, index) => (
            <div
              key={index}
              className={`event-item ${
                selectedEvent === event ? "selected" : ""
              }`}
              onClick={() => handleEventFilter(event)}
            >
              {t(event)}
            </div>
          ))}
        </div>
      </div>

      <div className="test-timeline">
        {items.map((item, index) => {
          const videoId = extractYouTubeID(item.url);
          const thumbnailUrl = videoId
            ? `https://img.youtube.com/vi/${videoId}/0.jpg`
            : "";
          return (
            <div
              className={`test-timeline-item ${
                index % 2 === 0 ? "left" : "right"
              }`}
              key={item._id}
            >
              <div className="test-timeline-circle">
                <img
                  src={mini3rd}
                  alt="QWER Logo"
                  className="test-timeline-circle-img"
                />
              </div>
              <div className="test-timeline-card">
                {thumbnailUrl && (
                  <img
                    src={thumbnailUrl}
                    alt={item.title}
                    className="thumbnail"
                    onClick={() => handleThumbnailClick(item.url)}
                  />
                )}
                <div className="test-timeline-title-container">
                  <h2>{item.title}</h2>
                </div>
                <div className="test-timeline-date">
                  {formatDate(item.uploadDate)}
                </div>
                <a
                  href={isMobile() ? getYouTubeAppLink(item.url) : item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="test-timeline-link"
                >
                  {t("watch")}
                </a>
              </div>
            </div>
          );
        })}
        <div ref={loader} className="loader">
          {isLoading && (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>{t("loading")}</p>
            </div>
          )}
        </div>

        <Analytics />
      </div>
      <footer className="footer">{t("footer")}</footer>
    </div>
  );
};

export default NewBawige;
